import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PostDetail from "@/pages/PostDetail";
import Archive from "@/pages/Archive";
import AdminLogin from "@/pages/AdminLogin";
import AdminPosts from "@/pages/AdminPosts";
import AdminEdit from "@/pages/AdminEdit";
import AdminImport from "@/pages/AdminImport";
import AdminDuplicates from "@/pages/AdminDuplicates";
import AdminExport from "@/pages/AdminExport";
import AdminUsers from "@/pages/AdminUsers";
import AdminAuthors from "@/pages/AdminAuthors";
import AdminStats from "@/pages/AdminStats";
import UserLogin from "@/pages/UserLogin";
import Reserved from "@/pages/Reserved";
import { getToken } from "@/lib/api";

const RequireAuth = ({ children }) => {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/archivio" element={<Archive />} />
          <Route path="/accedi" element={<UserLogin />} />
          <Route path="/riservati" element={<Reserved />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAuth><AdminPosts /></RequireAuth>} />
          <Route path="/admin/edit/:id" element={<RequireAuth><AdminEdit /></RequireAuth>} />
          <Route path="/admin/new" element={<RequireAuth><AdminEdit /></RequireAuth>} />
          <Route path="/admin/import" element={<RequireAuth><AdminImport /></RequireAuth>} />
          <Route path="/admin/duplicati" element={<RequireAuth><AdminDuplicates /></RequireAuth>} />
          <Route path="/admin/lettori" element={<RequireAuth><AdminUsers /></RequireAuth>} />
          <Route path="/admin/autori" element={<RequireAuth><AdminAuthors /></RequireAuth>} />
          <Route path="/admin/statistiche" element={<RequireAuth><AdminStats /></RequireAuth>} />
          <Route path="/admin/libro" element={<RequireAuth><AdminExport /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
